import React from 'react';
import './FloatingActionButton.css';

/**
 * Floating Action Button (FAB) Component
 * A circular button that floats at the bottom right of the screen on mobile
 * 
 * @param {Object} props - Component props
 * @param {function} props.onClick - Click handler
 * @param {string} props.icon - Icon class (e.g., 'fas fa-plus')
 * @param {string} props.label - Accessible label for screen readers
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Disabled state
 */
const FloatingActionButton = ({
  onClick,
  icon = 'fas fa-plus',
  label = 'Add',
  className = '',
  disabled = false,
  ...rest
}) => {
  return (
    <button
      className={`floating-action-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      {...rest}
    >
      <i className={icon}></i>
    </button>
  );
};

export default FloatingActionButton;

